export enum RegistrationStages {
    FirstStage = 1,
    SecondStage,
}
